import * as React from "react";
const SvgFiRrAgeRestrictionEighteen = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-age-restriction-eighteen_svg__a)">
      <path
        fill="#062147"
        d="M10.125 14.125A3.38 3.38 0 0 0 13.5 17.5a3.38 3.38 0 0 0 3.375-3.375c0-.958-.405-1.819-1.049-2.434a3.1 3.1 0 0 0 .799-2.066A3.13 3.13 0 0 0 13.5 6.5a3.13 3.13 0 0 0-3.125 3.125 3.1 3.1 0 0 0 .799 2.066 3.36 3.36 0 0 0-1.049 2.434M13.5 15.5a1.377 1.377 0 0 1-1.375-1.375c0-.758.617-1.375 1.375-1.375s1.375.617 1.375 1.375S14.258 15.5 13.5 15.5m-1.125-5.875c0-.62.505-1.125 1.125-1.125s1.125.505 1.125 1.125-.505 1.125-1.125 1.125-1.125-.505-1.125-1.125M24 12a1 1 0 0 1-1 1h-1v1a1 1 0 1 1-2 0v-1h-1a1 1 0 1 1 0-2h1v-1a1 1 0 1 1 2 0v1h1a1 1 0 0 1 1 1M7 16v-5.9l-.523.574a1.001 1.001 0 0 1-1.479-1.348L6.73 7.425a1.3 1.3 0 0 1 1.439-.334c.504.197.831.674.831 1.216V16a1 1 0 1 1-2 0m15.059 2.546A11.97 11.97 0 0 1 12 24C5.383 24 0 18.617 0 12S5.383 0 12 0c4.071 0 7.832 2.039 10.059 5.454a1 1 0 0 1-1.675 1.092A9.98 9.98 0 0 0 12 2C6.486 2 2 6.486 2 12s4.486 10 10 10a9.97 9.97 0 0 0 8.383-4.546 1 1 0 0 1 1.676 1.092"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-age-restriction-eighteen_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrAgeRestrictionEighteen;
